import {
    IBREPORTS_CONTRACT_DETAILS_FETCH,
    IBREPORTS_REBATE_EARNINGS_FETCH,
    IBREPORTS_SUMMARY_FETCH,
    IBREPORTS_TRADING_ACCOUNTS_FETCH,
    IBREPORTS_ACCOUNT_STATEMENT_FETCH,
    IBREPORTS_IS_FETCHING,
} from 'constants/ibReports'

export default function ibReportsReducer(state = {
			ibSummary: {
				data: [],
				header: []
			},
      ibContractDetails: {
        data: [],
        header: []
      },
      tradingAccounts: {
        data: [],
        header: []
      },
			accountStatement: {
				data: [],
				header: []
      },
      ibRebateEarnings: {
				data: [],
        header: [],
        additionalData: {}
			}
		}, action) {
    switch (action.type) {
        case IBREPORTS_SUMMARY_FETCH:
            return {
              ...state,
              ibSummary: action.payload,
            }
        case IBREPORTS_TRADING_ACCOUNTS_FETCH:
            return {
              ...state,
              tradingAccounts: action.payload,
            }
        case IBREPORTS_ACCOUNT_STATEMENT_FETCH:
            return {
              ...state,
              accountStatement: action.payload,
            }
        case IBREPORTS_IS_FETCHING:
            return {
              ...state,
              isFetching: action.payload,
						}
        case IBREPORTS_CONTRACT_DETAILS_FETCH:
						return {
							...state,
							ibContractDetails: {
                data: action.payload
              }
            }
        case IBREPORTS_REBATE_EARNINGS_FETCH:
            return {
              ...state,
              ibRebateEarnings: action.payload,
            }
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/ibReports.js